import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { ArrowLinkIcon, Card, Skeleton, Text } from "@ficatranquilo/contabilidade.com-ui";
import { escapeHtml, formatDate } from "@components/ow";

// Lista de projetos em cartões (modelo Lista em cartões do DS OneWork), usada pelo
// ADM em /c/projects e pelo prestador em /e/projects.

export const ProjectGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
`;

const Dates = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Foot = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.N100};
  color: ${({ theme }) => theme.colors.ACTION};

  svg {
    width: 14px;
  }
`;

export function ProjectCardsSkeleton() {
  return (
    <ProjectGrid aria-busy="true">
      {Array.from({ length: 3 }).map((_, i) => (
        <Card key={i}>
          <Skeleton $width="55%" $height="20px" $noFlex />
          <Skeleton $width="40%" $height="14px" $noFlex />
          <Skeleton $width="40%" $height="14px" $noFlex />
          <Skeleton $width="30%" $height="14px" $noFlex />
        </Card>
      ))}
    </ProjectGrid>
  );
}

/**
 * Cartão do projeto. `route` é o detalhe que ele abre; `showErp` mostra o código ERP
 * (interno da empresa, então fica de fora para o prestador).
 */
export function ProjectCard({ project, route, showErp = true }) {
  const navigate = useNavigate();

  return (
    // O cartão inteiro é o link: o href abre em outra aba pelo navegador; o clique
    // comum navega sem recarregar a página
    <Card
      $action={route}
      onClick={(event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        navigate(route);
      }}>
      <Text $text={escapeHtml(project.name)} $variant="h4_bold" $color="N900" />
      <Dates>
        <Text $text={`Início ${formatDate(project.start_date)}`} $variant="caption_medium" $color="N600" />
        <Text
          $text={project.end_date ? `Término ${formatDate(project.end_date)}` : "Sem término"}
          $variant="caption_medium"
          $color="N600"
        />
        {showErp && project.erp_code ? (
          <Text
            $text="Código ERP: %s"
            $replaces={[escapeHtml(project.erp_code)]}
            $variant="caption_medium"
            $color="N600"
          />
        ) : null}
      </Dates>
      <Foot>
        <Text $text="Ver detalhes" $variant="paragraph_small_bold" $color="ACTION" />
        <ArrowLinkIcon />
      </Foot>
    </Card>
  );
}
